var _defs, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.841,
    height: 33.841,
    viewBox: "0 0 33.841 33.841",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31.4,0H2.441A2.441,2.441,0,0,0,0,2.441V31.4a2.441,2.441,0,0,0,2.441,2.441H31.4A2.441,2.441,0,0,0,33.841,31.4V2.441A2.441,2.441,0,0,0,31.4,0ZM24.647,13.193q.011.25.011.5a10.975,10.975,0,0,1-11.05,11.05h0A10.993,10.993,0,0,1,7.654,23a7.9,7.9,0,0,0,.926.054A7.793,7.793,0,0,0,13.4,21.392a3.888,3.888,0,0,1-3.628-2.7,3.871,3.871,0,0,0,1.754-.067,3.885,3.885,0,0,1-3.116-3.807c0-.018,0-.033,0-.05a3.857,3.857,0,0,0,1.759.486,3.887,3.887,0,0,1-1.2-5.185,11.027,11.027,0,0,0,8.005,4.058A3.886,3.886,0,0,1,23.6,10.588a7.79,7.79,0,0,0,2.466-.943,3.9,3.9,0,0,1-1.708,2.148,7.746,7.746,0,0,0,2.23-.612,7.893,7.893,0,0,1-1.937,2.011Zm0,0",
    transform: "translate(0)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.76887c92.svg";
export { ForwardRef as ReactComponent };